import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['corporationId', 'communities']

  connect() {
    // converts select2 events into native events
    $(this.corporationIdTarget).on('select2:select', function() {
      let event = new Event('change', { bubbles: true })
      this.dispatchEvent(event)
    })
    this.toggleCommunities()
  }

  toggleCommunities() {
    this.getCommunities(this.corporationIdTarget.value)
  }

  getCommunities(corporationId) {
    let contactId = $('#contact_id').val()
    let communities = document.getElementsByClassName('choices-group')[0]

    if (corporationId) {
      $.get({
        url: '/admin/contacts/get_communities',
        data: {
          corporation_id: corporationId,
          contact_id: contactId
        },
        success: (results) => {
          $('#contact_communities_input').removeClass('visually-hidden')
          $(communities).replaceWith(`<div>${results}</div>`)
        }
      })
    }
  }
}